import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Header({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isAdmin = user?.role === 'admin';
  const isOnProductsPage = location.pathname === '/admin/products';
  const isOnUsersPage = location.pathname === '/admin/users';
  const isOnAnalyticsPage = location.pathname === '/admin/analytics';
  const isOnLeadsPage = location.pathname === '/admin';

  return (
    <div className="header">
      <div className="logo" aria-label="Food Forward Ventures">
        <img src="/logo.webp" alt="FFV" style={{ height: 48 }} />
      </div>
      {isAdmin && (
        <div className="flex gap-4 ml-8">
          <button
            onClick={() => navigate('/admin')}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              isOnLeadsPage && !isOnProductsPage && !isOnUsersPage && !isOnAnalyticsPage
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Leads
          </button>
          <button
            onClick={() => navigate('/admin/products')}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              isOnProductsPage
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Products
          </button>
          <button
            onClick={() => navigate('/admin/users')}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              isOnUsersPage
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Users
          </button>
          <button
            onClick={() => navigate('/admin/analytics')}
            className={`px-4 py-2 text-sm font-medium transition-colors ${
              isOnAnalyticsPage
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Analytics
          </button>
        </div>
      )}
      <div className="spacer" />
      <div className="user">{user?.name} ({user?.role})</div>
      <button className="link" onClick={onLogout}>Logout</button>
    </div>
  );
}
